import _ from 'underscore'

/**
 * Generate unique element IDs for SVG defs
 */
export function uniqueDefIds (suffix = `_${_.uniqueId()}`) {
  return {
    keywordBox: `keywordBox${suffix}`,
    barGradient: `barGradient${suffix}`,
    instructionsBoxShadow: `instructionsBoxShadow${suffix}`
  }
}
